import { RolesType } from "@auth/context/Auth.provider";
import { useAuthContext } from "@auth/context/Auth.context";
import { Navigate } from "react-router-dom";

interface AuthProps {
  roles: RolesType[];
  redirectTo?: string;
}

function withAuth<P extends object>(
  Component: React.ComponentType<P>
): React.FC<P & AuthProps> {
  const WrappedComponent = ({ roles, redirectTo = "/", ...props }: AuthProps & P) => {
    const { hasSomeResourceRole } = useAuthContext();
    
    const isAllowed = hasSomeResourceRole(...roles);

    if (!isAllowed) {
      return <Navigate to={redirectTo} replace />;
    }

    return <Component {...props as P} />;
  }
  
  WrappedComponent.displayName = `withAuth(${Component.displayName || Component.name || "Component"})`;

  return WrappedComponent;
}

export default withAuth;